<template>
  <el-dialog
    :title="title"
    width="80%"
    :visible.sync="visible"
    v-if="visible"
    :before-close="handleClose"
    destroy-on-close
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="150px">
      <el-row>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="批次号：" prop="batch">
              <el-input
                v-model="form.batch"
                disabled
                style="width: 55%"
              ></el-input>
              <span style="font-size: 12px; color: #ccc; margin-left: 10px"
                >批次号由系统自动生成</span
              >
            </el-form-item>
          </div></el-col
        >
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="报名开始时间:" prop="applyBeginDate">
              <el-date-picker
                v-model="form.applyBeginDate"
                :disabled="params.operateType === 'info' || disableBeginDate"
                type="datetime"
                :picker-options="beginDateOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
              >
              </el-date-picker>
              <el-checkbox class="checkbox" :disabled="params.operateType === 'info'" v-model="checked">无需人脸识别</el-checkbox>  <div class="tip">注：班级课程的批次都要人脸识别</div>
            </el-form-item>
          </div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="报名截止时间:" prop="applyEndDate">
              <el-date-picker
                v-model="form.applyEndDate"
                :disabled="params.operateType === 'info'"
                type="datetime"
                :picker-options="endDateOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="缴费截止时间:" prop="payTime">
              <el-date-picker
                v-model="form.payTime"
                :disabled="params.operateType === 'info'"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="开课时间:" prop="openTime">
              <el-date-picker
                v-model="form.openTime"
                :disabled="params.operateType === 'info' || disableOpenTime"
                type="datetime"
                :picker-options="openTimeOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="结课时间：" prop="endTime">
              <el-date-picker
                :disabled="params.operateType === 'info'"
                v-model="form.endTime"
                :picker-options="checkTimeOptions"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="课程考核结束时间：" prop="checkTime">
              <el-date-picker
                :disabled="params.operateType === 'info' || params.operateType==='add'?false:params.row.isSetCheckTime===1"
                v-model="form.checkTime"
                :picker-options="checkTimeOptions"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="任课老师:" prop="uids">
              <el-select
                style="width: 57%"
                v-model="form.uids"
                :disabled="params.operateType === 'info'"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in teacherUserList"
                  :key="item.uid"
                  :label="item.uname"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="报名批次：" prop="applyBatchId">
          
              <el-select
                style="width: 28%"
                v-model="form.batchTypeValue"
                :disabled="params.operateType === 'info'"
                filterable
                placeholder="请选择"
                @change="handleApplyBatch"
              >
                <el-option
                  v-for="item in applyBatchType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>

              <el-input
                v-if="form.batchTypeValue != '3'"
                style="width: 28%; margin-left: 2px"
                v-model="form.applyBatch"
                @input="change($event)"
                :disabled="
                  params.operateType === 'info' || form.batchTypeValue == '1'
                "
              ></el-input>
              <el-select
                style="width: 28%; margin-left: 2px"
                v-else
                v-model="form.applyBatchId"
                :disabled="params.operateType === 'info'"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in shareBatchList"
                  :key="item.id"
                  :label="item.batch"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="公开报名人数：" prop="count"
              ><el-input-number
                style="width: 55%"
                :min="0"
                v-model="form.count"
                :disabled="params.operateType === 'info'"
              ></el-input-number>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="对外招生人数：" prop="externalCount"
              ><el-input-number
                v-model="form.externalCount"
                :min="0"
                style="width: 55%"
                :disabled="params.operateType === 'info'"
              ></el-input-number>
            </el-form-item></div
        ></el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      style="width: 100%; display: inline-block; text-align: center"
    >
      <el-button
        v-if="params.operateType !== 'info'"
        type="primary"
        @click="submitForm"
        >确 定</el-button
      >
      <el-button type="" @click="closeDialog">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as api from '@/api/courseware/checkCourseware'
export default {
  props: {
    params: {
      type: Object,
      default: () => {},
    },
  },
  name: 'CourseOpeningAdd',
  data() {
    const validateApplyEndDate = (rule, value, callback) => {
      console.log('validateApplyEndDate', this.form)
      if (!value) {
        callback(new Error('必须选择'))
      } else {
        if (this.form.applyEndDate < this.form.applyBeginDate) {
          callback(new Error('截止报名时间不能早于开始报名时间'))
        } else {
          callback()
        }
      }
    }
    const validatePayTime = (rule, value, callback) => {
      console.log('validatePayTime', this.form)
      if (!value) {
        this.form.payTime = this.form.applyEndDate
        callback()
      } else {
        if (this.form.payTime < this.form.applyBeginDate) {
          callback(new Error('缴费截止时间不能早于报名开始时间'))
        } else {
          callback()
        }
      }
    }
    const validateOpenTime = (rule, value, callback) => {
      console.log('validateOpenTime', this.form)
      if (!value) {
        callback(new Error('必须选择'))
      } else {
        if (this.form.openTime < this.form.applyBeginDate) {
          callback(new Error('开课时间不能早于报名开始时间'))
        } else {
          callback()
        }
      }
    }
    const validateCheckTime = (rule, value, callback) => {
      console.log('validateCheckTime', this.form)
      if (!value) {
        this.form.checkTime = this.form.endTime
        callback()
      } else {
        // && this.form.checkTime <= this.form.endTime
        if (this.form.checkTime > this.form.openTime && this.form.checkTime <= this.form.endTime) {
          callback()
        } else {
          callback(new Error('考核结束时间不能早于开课时间并且不能晚于结课时间'))
        }
      }
    }
    const validateEndTime = (rule, value, callback) => {
      console.log('validateEndTime', this.form)
      if (!value) {
        callback(new Error('必须选择'))
      } else {
        if (this.form.endTime < this.form.openTime) {
          callback(new Error('结课时间不能早于开课时间'))
        } else {
          callback()
        }
      }
    }

    const validatorApplyBatchId = (rule, value, callback) => {
      console.log('validatorApplyBatchId', this.form)
      if (!this.form.batchTypeValue) {
        callback(new Error('必须选择'))
      } else {
        if (!this.form.applyBatch && !this.form.applyBatchId) {
          callback(new Error('必须选择'))
        } else {
          callback()
        }
      }
    }
    return {
      vid: this.$route.query.id,
      userType: '',
      mhId: '',
      visible: false,
      form: {
        batch: '',
        checkTime: '',
        openTime: '',
        applyEndDate: '',
        applyBeginDate: '',
        endTime: '',
        openTeacher: '',
        uids: '',
        payTime: '',
        applyBatchId: '',
        type: '',
        externalCount: 0,
        count: 0,
        batchTypeValue: '',
        checked:false
      },
      teacherUserList: [],
      rules: {
        batch: [{ required: true, message: '不能为空', trigger: 'blur' }],
        checkTime: [
          {
            required: false,
            trigger: 'change',
            validator: validateCheckTime,
          },
        ],
        applyBeginDate: [
          {
            required: true,
            message: '请选择日期',
            trigger: 'change',
          },
        ],
        applyEndDate: [
          {
            required: true,
            validator: validateApplyEndDate,
            trigger: 'change',
          },
        ],
        openTime: [
          {
            required: true,
            validator: validateOpenTime,
            trigger: 'change',
          },
        ],
        endTime: [
          {
            required: true,
            validator: validateEndTime,
            trigger: 'change',
          },
        ],
        payTime: [
          {
            required: false,
            validator: validatePayTime,
            trigger: 'change',
          },
        ],
        uids: [{ required: true, message: '不能为空', trigger: 'change' }],
        applyBatchId: [
          {
            required: true,
            validator: validatorApplyBatchId,
            trigger: 'change',
          },
        ],
        count: [
          {
            required: true,
            message: '必须填写',
            trigger: 'change',
          },
        ],
        externalCount: [
          {
            required: true,
            message: '必须填写',
            trigger: 'change',
          },
        ],
      },
      disableBeginDate: false,
      disableOpenTime: false,
      checkTimeOptions: this.dateOptions(0),
      beginDateOptions: this.dateOptions(1),
      endDateOptions: this.dateOptions(2),
      openTimeOptions: this.dateOptions(3),
      endTimeOptions: this.dateOptions(4),
      applyBatchType: [
        {
          value: '1',
          label: '单独批次',
        },
        {
          value: '2',
          label: '新增共有',
        },
        {
          value: '3',
          label: '已设共有',
        },
      ],
      shareBatchList: [],
    }
  },
  methods: {
    dateOptions(type) {
      return {
        disabledDate: (time) => {
          if (this.params.operateType !== 'edit') {
            return false
          }
          let formDate = ''
          if (type === 0) {
            // formDate = this.params.row.checkTime;
            formDate = this.params.row.openTime;
            // console.log('row',this.params)
          } else if (type === 1) {
            formDate = this.params.row.applyBeginDate
          } else if (type === 2) {
            formDate = this.params.row.applyEndDate
          } else if (type === 3) {
            formDate = this.params.row.openTime
          } else {
            formDate = this.params.row.endTime
          }
          return time.getTime() < new Date(formDate).getTime()
        },
      }
    },
    // 初始化
    init() {
      this.visible = true
    },
    handleApplyBatch(val) {
      if (val == 3) {
        api.getApplyBatchList().then(({ data }) => {
          if (data.code === 100000) {
            if (data.data) {
              this.shareBatchList = data.data
              let obj = data.data[0]
              this.form.applyBatchId = obj.id
              this.form.count = obj.count
              this.form.externalCount = obj.externalCount
            }
          }
        })
      } else if (val == 1) {
        this.form.applyBatch = this.form.batch
        this.form.applyBatchId = ''
        this.form.count = 0
        this.form.externalCount = 0
      } else {
        this.form.applyBatchId = ''
        this.form.count = 0
        this.form.externalCount = 0
        this.form.applyBatch = ''
      }
    },
    change(value) {
      console.log('change', value)
      this.$forceUpdate()
    },
    getUserByUid() {
      api.getUserByUid(this.getUId).then(({ data }) => {
        if (data.code === 100000) {
          this.userType = data.data.type
          if (this.userType === '56') {
            //任课老师
            this.teacherUserList.push({
              uid: data.data.uid,
              name: data.data.uname,
            })
          } else {
            this.getTeacherUser()
          }
          this.form.openTeacher = data.data.uname
          // this.getSchoolByUid()
        }
      })
    },

    getTeacherUser() {
      api.getTeacherUserList(this.getUId).then(({ data }) => {
        if (data.code === 100000) {
          console.log('getTeacherUserList', data)
          this.teacherUserList = data.data
        }
      })
    },
    getSchoolByUid() {
      api.getSchoolByUid(this.getUId).then(({ data }) => {
        if (data.code === 100000) {
          this.mhId = data.data.id
        }
      })
    },

    getMaxBatch() {
      api.getMaxBatch({ vid: this.vid }).then(({ data }) => {
        if (data.code === 100000) {
          this.form.batch = data.data
        }
      })
    },
    getCourseRecordDetail() {
      api
        .getCourseRecordDetail({ courseId: this.vid, id: this.id })
        .then(({ data }) => {
          if (data.code === 100000) {
            this.form = data.data[0]
          }
        })
    },
    // 处理弹窗关闭事件
    handleClose(msg) {
      this.visible = false
      this.resetForm()
      this.$emit('closeRecordDialog')
    },

    // 提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        console.log(33, valid, this.form)
        if (valid) {
          api
            .saveOrUpdateCourseRecord({
              ...this.form,
              type: this.form.batchTypeValue == '1' ? 1 : 2,
              videoId: this.vid,
              isNeedFaceRecognition: this.checked == true ? 0 : 1 ,
              mhId: this.mhId,
              createId: this.getUId,
              remark: '',
            })
            .then(({ data }) => {
              if (data.code === 100000) {
                this.$message.success(data.msg)
                this.visible = false
                this.resetForm()
                this.$emit('closeRecordDialog')
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.form = { ...this.initForm }
      this.disableBeginDate = false
      this.disableOpenTime = false
    },
    closeDialog() {
      this.visible = false
      this.$emit('closeRecordDialog')
    },
    confirm() {
      let params = {}
      for (let key in this.form) {
        if (key !== 'createDate' && key !== 'updateDate') {
          params[key] = this.form[key]
        }
      }
      api
        .saveOrUpdateCourseRecord({ ...params, updateId: this.getUId })
        .then(({ data }) => {
          if (data.code === 100000) {
            this.$message.success(data.msg)
          }
        })
    },
    edit() {
      this.$emit('editOpening')
    },
    handleOpenDialog(params) {
      this.visible = true
      this.getUserByUid()

      console.log('params', params)
      if (params.operateType === 'add') {
        this.getMaxBatch()
      } else {
        this.form = { ...params.row }
        this.form.uids = parseInt(this.form.uids)
        this.form.batchTypeValue = params.row.type;
        this.checked = params.row.isNeedFaceRecognition == 0 ? true : false
        if (params.operateType === 'edit') {
          //判断时间
          let nowDate = new Date()
          let applyBeginDate = new Date(this.form.applyBeginDate)
          let applyEndDate = new Date(this.form.applyEndDate)
          let endTime = new Date(this.form.endTime)
          if (
            nowDate.getTime() >= applyBeginDate.getTime() &&
            nowDate.getTime() < applyEndDate.getTime()
          ) {
            this.disableBeginDate = true
          }
          if (
            nowDate.getTime() > applyEndDate.getTime() &&
            nowDate.getTime() < endTime.getTime()
          ) {
            this.disableOpenTime = true
          }
          if(params.row.status==='开课中'){this.disableOpenTime = true}
        }
      }
    },
  },
  created() {
    // this.getUserByUid()
    // this.getMaxBatch()
    this.initForm = { ...this.form }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    title() {
      const title = {
        add: '添加开课时间',
        info: '查看开课时间',
        edit: '修改开课时间',
      }
      return title[this.params.operateType]
    },
  },
  watch: {
    params: {
      immediate: true,
      handler: function (newValue) {
        console.log('params', newValue)
        if (newValue && newValue.operateType) this.handleOpenDialog(newValue)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  @include flex(center, flex-start);
  .info {
    width: 50%;
    border-right: 1px solid #4e5359;
    &:nth-last-child(1) {
      border-right: none;
    }
    .info-title {
      @include font(18px, #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form {
    .el-form-item {
      margin-left: 40px;
      width: 80%;
    }
  }
}
</style>
<style>
.el-dialog {
  width: 60%;
}
.checkbox{
  margin-left: 15px;
}
.tip{
  color: red;
}
.chooseCourse {
  margin-right: 10px;
  font-size: 12px;
  line-height: 30px;
}
.courseChoose .courses {
  display: block;
  padding-left: 5%;
  padding-top: 10px;
}
.courseChoose {
  width: 25%;
  float: left;
  border-right: 1px dashed #ccc;
  margin-top: 20px;
  padding-bottom: 10px;
}
.courseChoose:last-child {
  border-right: none;
}
.el-checkbox__label {
  white-space: normal;
  padding-left: 5px;
}
</style>
